import React, { useMemo } from "react";
import FlexTable from "../../../components/ui-components/FlexTable";
import Badge from "../../../components/ui-components/Badge";

export default function InvestigationsTable({ data, onRowClick }) {
  const columns = useMemo(() => [
    { Header: "Title", accessor: "title", Cell: ({ row }) => (
        <div className="min-w-0"><div className="truncate font-medium text-text-2">{row.original.title}</div>
        <div className="truncate text-[12px] text-text-3">{scopeLabel(row.original.scope)}</div></div>) },
    { Header: "Status", accessor: "status", width: 120, Cell: ({ value }) => <Badge status={value} /> },
    { Header: "Confidence", accessor: "confidenceLabel", width: 110, Cell: ({ value }) => value ? <Badge status="custom" label={value} size="sm" /> : <span className="text-text-3">—</span> },
    { Header: "Updated", accessor: "updatedAt", width: 140, align: "right", Cell: ({ value }) => <span className="text-text-3">{value ? new Date(value).toLocaleDateString() : "—"}</span> },
  ], []);
  return <FlexTable columns={columns} data={data} onRowClick={onRowClick} rowAriaLabel={(r) => `Open ${r.title}`} />;
}
function scopeLabel(scope) {
  if (!scope) return "";
  const k = scope.kind || scope.Kind; const ref = scope.ref || scope.Ref;
  return ref ? `${k}: ${ref}` : (k || "");
}
